import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgCamera(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 10.75C12.5482 10.75 9.75 13.5482 9.75 17C9.75 20.4518 12.5482 23.25 16 23.25C19.4518 23.25 22.25 20.4518 22.25 17C22.25 13.5482 19.4518 10.75 16 10.75ZM12.25 17C12.25 14.9289 13.9289 13.25 16 13.25C18.0711 13.25 19.75 14.9289 19.75 17C19.75 19.0711 18.0711 20.75 16 20.75C13.9289 20.75 12.25 19.0711 12.25 17Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11 4.75C10.5821 4.75 10.1918 4.95888 9.95994 5.30662L8.33102 7.75L3 7.75C2.30964 7.75 1.75 8.30964 1.75 9L1.75 26C1.75 26.6904 2.30964 27.25 3 27.25L29 27.25C29.6904 27.25 30.25 26.6904 30.25 26L30.25 9C30.25 8.30964 29.6904 7.75 29 7.75L23.669 7.75L22.0401 5.30662C21.8082 4.95888 21.4179 4.75 21 4.75L11 4.75ZM10.0401 9.69338L11.669 7.25L20.331 7.25L21.9599 9.69338C22.1918 10.0411 22.5821 10.25 23 10.25H27.75L27.75 24.75L4.25 24.75L4.25 10.25H9C9.41794 10.25 9.80823 10.0411 10.0401 9.69338Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCamera);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
